/**
 * Loose matching for the search boxes.
 *
 * Case is ignored and so are the accents, because nobody types Butkovići with
 * the accent when they are looking for it, and Garaža should be found by
 * typing garaza. NFD splits č, ć, š and ž into a letter and a mark that can be
 * dropped; đ is its own letter and does not split, so it is handled by name.
 *
 * The terms are matched independently, so "ured rolete" finds "Rolete ured".
 * They do not have to be in order and they do not have to be whole words.
 */

export const normalise = (text) => String(text == null ? '' : text)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd');

/**
 * Whether every term of the query appears somewhere in the fields given.
 * An empty query matches everything, which is what an empty search box means.
 */
export const looseMatch = (query, fields) =>
{
    const terms = normalise(query).split(/\s+/).filter((one) => one !== '');

    if (terms.length === 0)
    {
        return true;
    }

    const haystack = fields
        .filter((one) => one != null)
        .map(normalise)
        .join(' ');

    return terms.every((term) => haystack.indexOf(term) !== -1);
};
